import { usePostAdminsUserIdResendverificationemail } from '@/api/generated/admin/admin'
import { usePostProvidersUserIdResendverificationemail } from '@/api/generated/doctor/doctor'
import { useAppDispatch } from '@/redux/hooks/useAppDispatch'
import { RESEND_INVITE_ERROR } from '@/store/member/MemberConstants'
import { userManagementTypes } from '../Constants'
import { getMemberApiErrorPayload } from './getMemberApiErrorPayload'

/**
 * Resends the verification email for a pending member (admin or provider).
 *
 * Replaces the `resendInvite` thunk + RESEND_INVITE* reducer flow. The old flow set a
 * `resendInviteSuccess` flag that drove the "Invitation Sent" popup (auto-cleared after 2s);
 * the caller now reproduces that via the returned `onSuccess` callback. On failure the
 * existing RESEND_INVITE_ERROR reducer case is preserved by dispatching it with the API
 * error body, so the error-message UX is unchanged.
 */
export function useResendInvite(userId: string, userType: string) {
  const dispatch = useAppDispatch()
  const isAdmin = userType === userManagementTypes.ADMIN
  const resendAdmin = usePostAdminsUserIdResendverificationemail()
  const resendProvider = usePostProvidersUserIdResendverificationemail()
  const activeMutation = isAdmin ? resendAdmin : resendProvider

  function mutate(opts?: { onSuccess?: () => void; onError?: (error: unknown) => void }) {
    activeMutation.mutate(
      { userId },
      {
        onSuccess: () => {
          opts?.onSuccess?.()
        },
        onError: (error) => {
          dispatch({ type: RESEND_INVITE_ERROR, payload: getMemberApiErrorPayload(error), failed: true })
          opts?.onError?.(error)
        },
      },
    )
  }

  return { mutate, isPending: activeMutation.isPending }
}
